export default {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, { token, data }) {
    state.status = 'success';
    state.isApiKey = data.isApiKey;
    // if impersonating a user, save the original token
    state.originalToken = data.originalToken;
    state.isImpersonating = !!data.originalToken;
    state.token = token;
    state.tokenTimestamp = new Date();
    state.user = data.user;
    state.access = data.access;
    state.primaryScopeIds = data.primaryScopeIds;
    state.primaryTenantIds = data.primaryTenantIds;
    state.tenantId = data.tenantId;
    state.tenantIdThemeSetting = data.user.properties.tenantIdThemeSetting;

    // for localhost development, also store in localStorage to persist across refreshes
    const isLocalhost = window.location.hostname === 'localhost';
    if (isLocalhost && process.env.VUE_APP_ENV === 'local') {
      localStorage.setItem('token', token);
      localStorage.setItem('tokenTimestamp', state.tokenTimestamp.toISOString());
      localStorage.setItem('userId', data.user.id);
    }
  },
  auth_error(state) {
    state.status = 'error';
    state.token = null;
    state.originalToken = null;
    state.user = {};
    state.tokenTimestamp = null;
  },
  logout(state) {
    state.status = '';
    state.token = null;
    state.originalToken = null;
    state.isImpersonating = false;
    state.user = {};
    state.access = [];
    state.tokenTimestamp = null;
    localStorage.clear();
    sessionStorage.clear();
  },
};
